import { render, staticRenderFns } from "./Competencies.vue?vue&type=template&id=3aaca07d&scoped=true"
import script from "./Competencies.vue?vue&type=script&lang=js"
export * from "./Competencies.vue?vue&type=script&lang=js"
import style0 from "./Competencies.vue?vue&type=style&index=0&id=3aaca07d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaca07d",
  null
  
)

export default component.exports